import React from 'react'
import SectionedContent from '../sectioned-content'

export default function SectionedContentDisplay(props) {
  const page = props?.node

  return <SectionedContent page={page} />
}
